export const typeDataToArray = async (dataFunc) => {
    switch (dataFunc.type) {
        case 0:
            return await dataFunc.generator();
        case 1:
            return await Promise.all(dataFunc.generator());
        case 2:
            const data = await dataFunc.generator();
            return await Promise.all(data);
    }
};
